import axios from "axios"
import { API_BASE_URL } from "../config"

export const changeViewMode = async (view_mode: number, catv_id: string, estate_id: string, admin_password: string) => {
  for (let i = 0; i < 3; i++) {
    try {
      const response = await axios.post(`${API_BASE_URL}/maintenance/change_view_mode`, {
        session_code: localStorage.getItem("session_code"),
        view_mode: view_mode,
        catv_id: catv_id,
        estate_id: estate_id,
        admin_password: admin_password
      })

      if (response.data.session_code) {
        localStorage.setItem("session_code", response.data.session_code)
      }

      return response.data
    } catch (error: any) {
      if (error.code && error.code == "ERR_NETWORK" && i != 2) {
        continue
      }
      throw error
    }
  }
}
